import { styled } from '@storybook/theming';

import {
  TrainFilled,
  PlaneIcon,
  MapPin,
  HotelBuild,
  ShipOutline,
  BusIcon,
  SwipeIcon,
} from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;

const TRANSPORTATION_TYPES = {
  // Plane transportation types
  PLANE: 'UTHY',
  FRANCE_AIRLINES: 'UAIF',
  ALITALIA_AIRLINES: 'UALI',
  AMERICAN_AIRLINES: 'UAME',
  ANADOLU_AIRLINES: 'UANJ',
  ATLASGLOBAL_AIRLINES: 'UATL',
  BRITISH_AIRLINES: 'UBRT',
  EMIRATES_AIRLINES: 'UEMR',
  PLANE_PLANE: 'UGUD',
  KLM: 'UKLM',
  LUFTHANSA: 'ULFT',
  LOT_AIRLINES: 'ULOT',
  PEGASUS: 'UPGS',
  QATAR_AIRLINES: 'UQAT',
  SINGAPUR_AIRLINES: 'USNG',
  UNITED_AIRLINES: 'UUNI',

  TRAIN: 'TGTDK',
  OUTOBUS: 'OGOD',
  MAPPIN: 'GBRL',
  SHIP: 'GGGD',
  HOTEL: 'OBBB',
  BOAT: 'TGTD',
  PLANE_SHIP: 'UGGD',
  OUTOBUS_PLANE: 'OGUD',
  SHIP_PLANE: 'GGUD',
  PLANE_OUTOBUS: 'UGOD',
};

export const getTransportationIcon = (type: string) => {
  switch (type) {
    case TRANSPORTATION_TYPES.TRAIN:
      return TrainFilled;
    case TRANSPORTATION_TYPES.PLANE:
    case TRANSPORTATION_TYPES.ALITALIA_AIRLINES:
    case TRANSPORTATION_TYPES.AMERICAN_AIRLINES:
    case TRANSPORTATION_TYPES.ANADOLU_AIRLINES:
    case TRANSPORTATION_TYPES.ATLASGLOBAL_AIRLINES:
    case TRANSPORTATION_TYPES.QATAR_AIRLINES:
    case TRANSPORTATION_TYPES.EMIRATES_AIRLINES:
    case TRANSPORTATION_TYPES.KLM:
    case TRANSPORTATION_TYPES.PLANE_PLANE:
    case TRANSPORTATION_TYPES.UNITED_AIRLINES:
    case TRANSPORTATION_TYPES.SINGAPUR_AIRLINES:
    case TRANSPORTATION_TYPES.PEGASUS:
    case TRANSPORTATION_TYPES.LUFTHANSA:
    case TRANSPORTATION_TYPES.LOT_AIRLINES:
    case TRANSPORTATION_TYPES.BRITISH_AIRLINES:
      return PlaneIcon;

    case TRANSPORTATION_TYPES.MAPPIN:
      return MapPin;

    case TRANSPORTATION_TYPES.SHIP:
    case TRANSPORTATION_TYPES.BOAT:
      return ShipOutline;

    case TRANSPORTATION_TYPES.HOTEL:
      return HotelBuild;

    case TRANSPORTATION_TYPES.OUTOBUS:
      return BusIcon;

    default:
      return undefined;
  }
};

export const getCustomTransportationIcon = (type: string) => {
  if (
    type === TRANSPORTATION_TYPES.PLANE_OUTOBUS ||
    type === TRANSPORTATION_TYPES.OUTOBUS_PLANE ||
    type === TRANSPORTATION_TYPES.SHIP_PLANE ||
    type === TRANSPORTATION_TYPES.PLANE_SHIP
  )
    return (
      <Wrapper>
        <CustomIcon
          icon={
            type === TRANSPORTATION_TYPES.PLANE_OUTOBUS ||
            type === TRANSPORTATION_TYPES.PLANE_SHIP
              ? PlaneIcon
              : type === TRANSPORTATION_TYPES.OUTOBUS_PLANE
              ? BusIcon
              : type === TRANSPORTATION_TYPES.SHIP_PLANE
              ? ShipOutline
              : PlaneIcon
          }
          fontSize={16}
          paletteColor='primaryBrand'
        />
        <CustomIcon icon={SwipeIcon} fontSize={16} paletteColor='darkGrey' />
        <CustomIcon
          icon={
            type === TRANSPORTATION_TYPES.PLANE_OUTOBUS
              ? BusIcon
              : type === TRANSPORTATION_TYPES.OUTOBUS_PLANE ||
                type === TRANSPORTATION_TYPES.SHIP_PLANE
              ? PlaneIcon
              : type === TRANSPORTATION_TYPES.PLANE_SHIP
              ? ShipOutline
              : PlaneIcon
          }
          fontSize={16}
          paletteColor='primaryBrand'
        />
      </Wrapper>
    );

  return null;
};
